module.exports = __webpack_public_path__ + "static/media/Iceland2.ccad1051.png";


//////////////////
// WEBPACK FOOTER
// ./src/Iceland2.png
// module id = 38
// module chunks = 0